export enum FeedbackType {
  Yes = 'YES',
  No = 'NO'
}
export type FeedbackStates = FeedbackType.Yes | FeedbackType.No | '';

export type FeedbackAnswerKey =
  | 'UNCLEAR_INFO'
  | 'BROKEN_DATA'
  | 'DID_NOT_HELP'
  | 'LONG_SEARCH_TIME';
